import { exopenApi } from "src/common/redux/api/exopenApi.js";

export interface PowerBiReport {
	id: string;
	name: string;
	workspaceId: string;
	workspaceName: string;
	/** Null for report types Power BI doesn't give a web link for. */
	webUrl: string | null;
}

const powerBiReportsApi = exopenApi.injectEndpoints({
	endpoints: (builder) => ({
		getPowerBiReports: builder.query<PowerBiReport[], string>({
			query: (companyDomainId) => `api/v1/powerbi/${companyDomainId}/reports`,
		}),
		/** Cheap check for the product tile and menu — the reports call queries Power BI itself. */
		getPowerBiConnectionStatus: builder.query<{ connected: boolean }, string>({
			query: (companyDomainId) =>
				`api/v1/powerbi/${companyDomainId}/connection/status`,
		}),
		getPowerBiAuthorizeUrl: builder.query<
			{ url: string },
			{ companyDomainId: string; returnUrl: string }
		>({
			query: ({ companyDomainId, returnUrl }) => ({
				url: `api/v1/powerbi/${companyDomainId}/connect/authorize-url`,
				params: { returnUrl },
			}),
			// WHY: the URL carries a state that expires after ten minutes, so never reuse one.
			keepUnusedDataFor: 0,
		}),
	}),
});

export const {
	useGetPowerBiReportsQuery,
	useGetPowerBiConnectionStatusQuery,
	useLazyGetPowerBiAuthorizeUrlQuery,
} = powerBiReportsApi;
